module.exports = __webpack_public_path__ + "img/logo.f858b7b7.png";